module.exports = __webpack_public_path__ + "img/track_w.ce902e59.svg";